import { css, styled } from "styled-components";

const BUTTON_X_OFFSET = 100;

export const Button = styled.button<{
  $isVisible: boolean;
  $rotation: number;
  $color: string;
  $isRightButton: boolean;
  $placeButtonsOverCards: boolean;
}>`
  position: absolute;
  left: -${({ $placeButtonsOverCards }) =>
      $placeButtonsOverCards ? 0 : BUTTON_X_OFFSET}px;
  top: 0;
  z-index: 3;
  color: inherit;
  outline: none;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  pointer-events: ${({ $isVisible }) => ($isVisible ? "auto" : "none")};
  transition: opacity 0.2s;
  height: 100%;
  width: 40px;
  background: transparent;
  border: none;
  background-image: linear-gradient(
    ${({ $rotation }) => $rotation - 90}deg,
    ${({ $color }) => $color},
    transparent 20px
  );
  border-left: ${({ $color }) =>
    $color !== "white" ? "1px solid #eee" : "none"};
  cursor: pointer;

  ${({ $isRightButton, $placeButtonsOverCards }) =>
    $isRightButton &&
    css`
      left: unset;
      right: -${$placeButtonsOverCards ? 0 : BUTTON_X_OFFSET}px;
    `}
`;

export const Icon = styled.div<{ $rotation: number; $arrowOffset: number }>`
  transform: rotate(${({ $rotation }) => $rotation}deg)
    translateX(${({ $arrowOffset }) => $arrowOffset ?? 0}px);
  display: flex;
  align-items: center;
  justify-content: center;

  padding-left: 4px;
  height: 44px;
  width: 44px;

  border-radius: 50%;
  background: rgb(255 255 255 / 0.8);
  box-shadow: 0 0 10px 0 rgb(0 0 0 / 0.25);
  backdrop-filter: blur(2px);
  color: #808893;
`;
